import React, {useState} from "react"
import {useQuery} from "react-query"
import useAuth from "auth/useAuth"
import useSeasons from "hooks/useSeasons"
import RescuesInfo from "./RescuesInfo"
import RescuesChart from "./RescuesChart"
import RescuersTable from "./RescuersTable"
import Spinner from "components/Spinner"


export default function SeasonTab() {

    const {seasons, season, setSeason} = useSeasons()
    const {auth, API} = useAuth()
    const {data, isLoading} = useQuery(
        ["season_rescues", season],
        () => auth(API.analyticsTypeGet, {type: 'season_rescues', season}).then(response => response.data)
    )

    return <>
        <h1>
            <span>Sezona</span>
            <select value={season} onChange={e => setSeason(e.target.value)}>
                {Object.entries(seasons).map(([season, desc]) => <option key={season} value={season}>{desc}</option>)}
            </select>
        </h1>

        {isLoading ? <Spinner/> : <>
            <RescuesInfo data={data?.areas}/>
            <RescuesChart data={data?.days}/>
            <RescuersTable data={data?.rescuers}/>
        </>}
    </>
}
